module.exports = __webpack_public_path__ + "img/zoya.e05be629.jpg";